"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _base = require("@atlaskit/icon/base");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var ChevronDownIcon = function ChevronDownIcon(props) {
  return (
    /*#__PURE__*/
    _react.default.createElement(_base.Icon, Object.assign({
      dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" role=\"presentation\"><path d=\"M8.292 10.293a1.009 1.009 0 000 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.01 1.01 0 000-1.419.987.987 0 00-1.406 0l-2.298 2.317-2.307-2.327a.99.99 0 00-1.406 0z\" fill=\"currentColor\" fill-rule=\"evenodd\"/></svg>"
    }, props))
  );
};

ChevronDownIcon.displayName = 'ChevronDownIcon';
var _default = ChevronDownIcon;
exports.default = _default;